import ReportsClient from './ReportsClient';
import AuthClient from './AuthClient';
import TimelineClient from './TimelineClient';
import SlotClient from './SlotClient';
import DiscountCodeClient from './DiscountCodeClient';
import DownloadClient from './DownloadClient';
import TenantsParkingClient from './TenantsParkingClient';
import TicketClient from './TicketClient';
import VisitorClient from './VisitorClient';
import RatesCalendarClient from './RateClient';
import EventClient from './EventClient';
import VisitorCodeClient from './VisitorCodeClient';
import ExperimentsCalendarClient from './ExperimentClient';
import TrackingClient from './TrackingClient';
import PayoutsClient from './PayoutsClient';
import InviteClient from './InviteClient';
import OperationsRegionClient from './OperationsRegion';
import OrganizationClient from './OrganizationClient';
import UploadClient from './UploadClient';
import TransactionReportsClient from './TransactionReportsClient';
import PropertyInsightsClient from './PropertyInsightsClient';
import DocumentsClient from './DocumentsClient';
import env from 'env';

const baseUrl = new URL(`${env.API_DOMAIN}${env.API_PATH}`);
const baseOrigin = new URL(baseUrl.origin);
const enforcementBaseUrl = new URL('/api/enforcements/', baseUrl.origin);

export const reportClient = new ReportsClient({ baseUrl });
export const authClient = new AuthClient({ baseUrl: baseOrigin });
export const timelineClient = new TimelineClient({ baseUrl });
export const ticketClient = new TicketClient({ baseUrl: enforcementBaseUrl });
export const slotClient = new SlotClient({ baseUrl });
export const discountCodeClient = new DiscountCodeClient({ baseUrl });
export const downloadClient = new DownloadClient({ baseUrl: baseOrigin });
export const tenantsParkingClient = new TenantsParkingClient({ baseUrl });
export const visitorClient = new VisitorClient({ baseUrl });
export const ratesCalendarClient = new RatesCalendarClient({ baseUrl });
export const experimentsCalendarClient = new ExperimentsCalendarClient({ baseUrl });
export const eventClient = new EventClient({ baseUrl });
export const visitorCodesClient = new VisitorCodeClient({ baseUrl });
export const inviteClient = new InviteClient({ baseUrl });
export const trackingClient = new TrackingClient({ baseUrl });
export const transactionReportsClient = new TransactionReportsClient({ baseUrl });
export const propertyInsightsClient = new PropertyInsightsClient({ baseUrl });
export const payoutsClient = new PayoutsClient({ baseUrl });
export const operationsRegionClient = new OperationsRegionClient({ baseUrl });
export const organizationClient = new OrganizationClient({ baseUrl });
export const uploadClient = new UploadClient({ baseUrl });
export const documentsClient = new DocumentsClient({ baseUrl });
